// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Search20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Search20Circle: FC<Search20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm1.011-9.9 4.9 4.9L19 17.911l-4.9-4.9a4.74 4.74 0 0 0 1.011-2.956c0-1.412-.49-2.608-1.468-3.587C12.664 5.49 11.468 5 10.056 5c-1.413 0-2.61.49-3.588 1.468C5.49 7.447 5 8.643 5 10.056c0 1.413.49 2.608 1.468 3.587.979.979 2.175 1.468 3.588 1.468A4.74 4.74 0 0 0 13.01 14.1Zm-.476-1.565c-.68.68-1.507 1.02-2.48 1.02-.972 0-1.798-.34-2.479-1.02-.68-.68-1.02-1.507-1.02-2.48 0-.972.34-1.798 1.02-2.479.68-.68 1.507-1.02 2.48-1.02.972 0 1.798.34 2.479 1.02.68.68 1.02 1.507 1.02 2.48 0 .972-.34 1.798-1.02 2.479Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Search20Circle;
